import type { FC, ReactElement } from 'react';
import { createPortal } from 'react-dom';

interface PortalizerProps {
  children: ReactElement;
  selector: string;
}

export const Portalizer: FC<PortalizerProps> = ({ children, selector }) => {
  const portalRoot = document.querySelector(selector);
  if (portalRoot) {
    return createPortal(children, portalRoot);
  }

  return null;
};
